const GENERIC_HOTEL_LOYALTY_POINTS_EARN_LABEL = 'Earn loyalty points'

export function formatHotelLoyaltyPointsEarnLabel(loyaltyProgramName?: string): string {
  if (!loyaltyProgramName) {
    return GENERIC_HOTEL_LOYALTY_POINTS_EARN_LABEL
  }

  return `Earn ${loyaltyProgramName} points`
}
